import * as React from 'react'
import { getTruncatedStyles } from './hooks'

import Typography from '@mui/material/Typography'
import { useTheme } from '@mui/material/styles'

type Props = {
  truncated: boolean
  children: React.ReactNode
}

export function TruncatedText(props: Props) {
  const { truncated, children } = props
  const styles = getTruncatedStyles(useTheme())
  const className = truncated ? styles.truncate : undefined

  return Boolean(children) ? (
    <Typography sx={{ ...className, whiteSpace: 'break-spaces' }}>
      {children}
    </Typography>
  ) : null
}
